import type { Me } from '@pickpro/contracts';
import { SPORTS } from '@pickpro/domain';

export const sessionDestination = (user: Me, locale: string = user.settings.locale): string => {
  if (user.role === 'admin') return `/${locale}/admin`;
  if (user.planStatus === 'inactive') return `/${locale}/access`;
  const preferred = user.settings.defaultSport;
  const sport =
    preferred && user.sports.includes(preferred)
      ? preferred
      : SPORTS.find((candidate) => user.sports.includes(candidate));
  return sport ? `/${locale}/${sport}` : `/${locale}/access`;
};
